export class ReportModalController {

  constructor($scope, $modalInstance, $route, toastr, $rootScope, UserService) {
    $scope.vm = this;
    this.scope = $scope;
    this.route = $route;
    this.userId = this.route.current.params.id;
    this.toastr = toastr;
    this.rootScope = $rootScope;
    this.UserService = UserService;
    this.scope.cancel = () => {
        $modalInstance.dismiss('cancel');
    };
    this.scope.report = {};
  }

  setReport(formReport){
    if(!formReport.$valid){
      this.formValidationForReport(formReport);
    } else if(confirm('?Seguro que quieres enviar el reporte?')){
        var params = {
          applicant: this.rootScope.currentUserProfile._id,
          user: this.userId,
          subject: this.scope.report.subject,
          content: this.scope.report.description
        };
        this.scope.cancel();
        this.toastr.info(`El reporte ha sido enviado`);

        this.UserService.sendReport(params)
          .then((_res) => { let response = _res.data;
          })
          .catch((response) => { let error = response.data;
            console.log(error);
          });
    }
  }

  formValidationForReport(form){
    if(!form.$valid){
      Object.keys(form).every((key, index, value) => {
        let findErr = true;
        switch (key) {
          case 'subject':
            if(form[key].$invalid){
              this.toastr.error('Debe indicar el asunto');
              break;
            }
          case 'description':
            if(form[key].$invalid){
              this.toastr.error('Debe indicar el mensaje');
              break;
            }
          default:
            findErr = false;
            break;
        }
        if(findErr){
          $('form[name="'+ form.$name +'"] *[name="'+ key +'"]')[0].focus();
          return;
        }
        return key.length;
      });
      return;
    }
    return true;
  };

  reportModalClose() {
    $modalInstance.close();
  }

}
